import Substore from "../Substore";

export default class TaskModalStore extends Substore {
  index = -1;
  completed = false;
}
